import { render, staticRenderFns } from "./InvoiceLeadsTable.vue?vue&type=template&id=28227953&scoped=true&"
import script from "./InvoiceLeadsTable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./InvoiceLeadsTable.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./InvoiceLeadsTable.vue?vue&type=style&index=0&id=28227953&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28227953",
  null
  
)

export default component.exports